import { render, staticRenderFns } from "./PartialStats.vue?vue&type=template&id=11c1ba34&"
import script from "./PartialStats.vue?vue&type=script&lang=js&"
export * from "./PartialStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports